import axios from 'axios';
import env from '../../env';
import { authProvider, authenticationParameters } from '../provider/authProvider';
import { jwtDecode } from 'jwt-decode';
import * as moment from 'moment';

const ID_TOKEN = "msal.idtoken";

let api = axios.create({
    baseURL: env.BASE_URL_API,
    headers: {
        Authorization: `Bearer `
    }
});

api.interceptors.request.use(config => {
    if (window !== undefined) {
        const bearer = localStorage.getItem(ID_TOKEN);
        config.headers['Authorization'] = `Bearer ${bearer}`;
    }
    return config;
});

api.interceptors.request.use(async config => {
    if (window !== undefined) {
        let bearer = localStorage.getItem(ID_TOKEN);
        const decoded = jwtDecode(bearer)
        const timeCompare = moment().add(0, 'm').toDate().getTime() / 1000;
        config.headers['Authorization'] = `Bearer ${bearer}`;
        if (timeCompare > decoded.exp) {
            const auth = await authProvider.acquireTokenSilent(authenticationParameters);
            bearer = auth.idToken.rawIdToken;
            config.headers['Authorization'] = `Bearer ${bearer}`;
        }
    }
    return config;
});

api.interceptors.response.use(response => response, async err => {
    if (err.response && err.response.status === 401) {
        await authProvider.acquireTokenSilent(authenticationParameters);
    }
    return Promise.reject(err);
});


export default api;
